import React from 'react'
import { FarmerDashboardLayout } from '../layouts';
import ProfileImage from '../../application/assets/images/farmerspages/profilepage.png'


function FarmerProfile() {


    return (
        <FarmerDashboardLayout>


            <div className='  '>

                <img src={ProfileImage} alt="" />

            </div>


        </FarmerDashboardLayout>
    )
}

export default FarmerProfile